import { render, staticRenderFns } from "./consumeDetail.vue?vue&type=template&id=3e9ba083&scoped=true&"
import script from "./consumeDetail.vue?vue&type=script&lang=js&"
export * from "./consumeDetail.vue?vue&type=script&lang=js&"
import style0 from "./consumeDetail.vue?vue&type=style&index=0&id=3e9ba083&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9ba083",
  null
  
)

export default component.exports